/*
 * dun-packs-carousel.js
 * Packs home carousel: the card closest to the horizontal center of the track
 * gets the .dh-pack--ink (black) treatment, updated live while scrolling.
 * Vanilla JS, no deps. Wrapped so it runs whether the DOM is ready or not.
 */
(function () {
  function initTrack(track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.dh-pack'));
    if (cards.length < 2) return; // nothing to highlight with 0/1 card

    var ticking = false;

    function update() {
      ticking = false;
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var best = null;
      var bestDist = Infinity;

      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = cards[i];
        }
      }

      for (var j = 0; j < cards.length; j++) {
        cards[j].classList.toggle('dh-pack--ink', cards[j] === best);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update(); // initial state (first card is centered at scroll 0)
  }

  function init() {
    var tracks = document.querySelectorAll('.dh-packs__grid');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
